/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Contact } from '../../core/models/common/Contact';

/**
 * Constructor.
 * @class
 * @extends Contact
 * @author eric.wittmann@gmail.com
 */
export abstract class OasContact extends Contact {
    public constructor() {
        super();
    }
}
OasContact["__class"] = "io.apicurio.datamodels.openapi.models.OasContact";
OasContact["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




